type SimpleProps = {
  children: React.ReactNode;
  className?: string;
};

export const borderColor = "border-[#C1AC96]";
export const primaryText = "text-[#A62A26]";
export const rowClass = `border-b ${borderColor}`;
export const cellClass = "p-4";

export function Label({ children, className = "" }: SimpleProps) {
  return (
    <span className={`font-semibold ${primaryText} ${className}`}>
      {children}
    </span>
  );
}

export function Row({ children, className = "" }: SimpleProps) {
  return <div className={`${rowClass} ${className}`}>{children}</div>;
}

export function Cell({ children, className = "" }: SimpleProps) {
  return <div className={`${cellClass} ${className}`}>{children}</div>;
}
